import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import { TimePicker } from '../time-picker';
import styles from './date-time-field.scss';
import { DatePicker } from '../date-picker';
export function DateTimeField(_ref) {
  let {
    use24HourFormat = false,
    onBlur,
    onChange,
    onFocus,
    inputId,
    ariaLabelledBy,
    value,
    id,
    disabled,
    errors,
    hidePlaceholder,
    required,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const [date, time] = useMemo(() => (value == null ? void 0 : value.split(' ')) ?? [], [value]);
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(styles.fields, {
      [styles.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy,
    required: required
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: disabled,
    errors: errors,
    hidePlaceholder: hidePlaceholder,
    required: required,
    id: id,
    onChange: newDate => onChange([newDate, time].join(' ')),
    value: date
  }), /*#__PURE__*/React.createElement(TimePicker, {
    disabled: disabled,
    error: errors.TIME,
    hidePlaceholder: hidePlaceholder,
    required: required,
    className: styles.time,
    "data-hook": `${id}-time`,
    use24Hours: use24HourFormat,
    onChange: newTime => onChange([date, newTime].join(' ')),
    value: time
  }));
}
//# sourceMappingURL=date-time-field.js.map